import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { ServerMsgResponse } from '@domain/entities/general.model';
import { ProfessionalGateway } from '@domain/gateway/professional-gateway';
import {
    ProfessionalModel,
    ProfessionalServerModel,
} from '@domain/entities/professional.model';
import { GeneralResponse } from '@domain/entities/general.model';
import { environment } from '@env/environment';
import { ProfessionalMock } from 'app/modules/main/professionals/list/professional-list.config';

@Injectable({
    providedIn: 'root',
})
export class ProfessionalService extends ProfessionalGateway {
    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Create a professional
     * @param form {Required}
     * @returns Observable of general response
     */
    create(form: ProfessionalModel): Observable<ServerMsgResponse> {
        return this._http.post<ServerMsgResponse>(
            `${environment.host}api/v1/professionals`,
            form
        );
    }

    /**
     * @description Update a professional
     * @param form {Required}
     * @returns Observable of general response
     */
    update(form: ProfessionalModel): Observable<ServerMsgResponse> {
        return this._http.put<ServerMsgResponse>(
            `${environment.host}api/v1/professionals`,
            form
        );
    }

    /**
     * @description Get professionals
     * @param params (Optional)
     * @returns Observable of professional entity
     */
    read(
        params?: HttpParams
    ): Observable<GeneralResponse<ProfessionalServerModel>> {
        return of({
            paginate_info: {
                items: 1,
                start: 1,
                total_items: 1,
                total_pages: 1,
            },
            data: ProfessionalMock,
        });
        /* return this._http.get<GeneralResponse<ProfessionalServerModel[]>>(
            `${environment.host}api/v2/professionals`,
            {
                params,
            }
        ); */
    }

    /**
     * @description Delete a professional
     * @param id {required}
     * @returns Observable of general response
     */
    delete(id: string): Observable<ServerMsgResponse> {
        return this._http.delete<ServerMsgResponse>(
            `${environment.host}api/v1/professionals/${id}`,
            {}
        );
    }

    createPhone(
        idProfesional: string,
        phone: string
    ): Observable<ServerMsgResponse> {
        return this._http.post<ServerMsgResponse>(
            `${environment.host}api/v1/people/contact_phones`,
            {
                id_: idProfesional,
                phone_number: phone,
            }
        );
    }
    deletePhone(
        idProfesional: string,
        phone: string
    ): Observable<ServerMsgResponse> {
        return this._http.delete<ServerMsgResponse>(
            `${environment.host}api/v1/people/contact_phones`,
            {
                params: new HttpParams()
                    .set('id_', idProfesional)
                    .set('phone_number', phone),
            }
        );
    }

    readById(id: string): Observable<ProfessionalServerModel> {
        /* return this._http.get<ProfessionalServerModel>(
            `${environment.host}api/v1/professionals/filter?id_=${id}`
            ); */
        let professional = ProfessionalMock.find((element) => element.id == id);
        return of(professional);
    }

    updateStudy(form: any): Observable<ServerMsgResponse> {
        return this._http.put<ServerMsgResponse>(
            `${environment.host}api/v1/professionals`,
            form
        );
    }

    getPhoto(id: string): Observable<Blob> {
        return this._http.get(
            `${environment.host}api/v1/professionals/card_photo`,
            {
                responseType: 'blob',
                params: new HttpParams().set('id_', id),
            }
        );
    }

    updatePhoto(form: FormData): Observable<Blob> {
        return this._http.put(
            `${environment.host}api/v1/professionals/card_photo`,
            form,
            {
                responseType: 'blob',
            }
        );
    }

    laborAspect(form: any): Observable<ServerMsgResponse> {
        return this._http.post<ServerMsgResponse>(
            `${environment.host}api/v1/professionals/labor_aspect`,
            form
        );
    }

    getLaborAspect(id: string): Observable<any> {
        return this._http.get<any>(
            `${environment.host}api/v1/professionals/labor_aspect`,
            {
                params: new HttpParams().set('id_professional', id),
            }
        );
    }
}
